import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { discountPoliciesMessages } from 'src/features/discountPolicies/utils/messages';
import DiscountPoliciesTable from 'src/features/discountPolicies/components/tables/DiscountPoliciesTable';

const DiscountPoliciesLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(discountPoliciesMessages.discountPolicies));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <DiscountPoliciesTable />;
};

export default DiscountPoliciesLayout;
